import React from 'react';
import { useTranslation } from 'react-i18next';
import AuthShell from './AuthShell';
import { Head } from './parts';

/** sessionStorage flag: the login page sets it, the router consumes it. */
export const OPENING_FLAG = 'pp_opening_dashboard';

export const consumeOpeningFlag = () => {
  try { const v = sessionStorage.getItem(OPENING_FLAG) === '1'; sessionStorage.removeItem(OPENING_FLAG); return v; } catch { return false; }
};
export const peekOpeningFlag = () => { try { return sessionStorage.getItem(OPENING_FLAG) === '1'; } catch { return false; } };

/**
 * «جارٍ فتح لوحة التحكم…» — the prototype's login-success state. Shown only while the
 * dashboard's company data is REALLY loading right after a sign-in (no artificial delay).
 */
export default function OpeningDashboard() {
  const { t } = useTranslation();
  return (
    <AuthShell>
      <Head icon="ok" tone="good" title={t('authPage.login.success')} text=""><div className="ppa-bar"><i /></div></Head>
    </AuthShell>
  );
}
